"use strict";

PF.Slider = class Slider extends PF.List
	{
	static get options()
		{
		return {
			enableHeader: false,
			searchable: false,
			html: PF.Slider.templates,
			itemClass: PF.Slider.Item,
			current: 0
		};
		}

	static get templates()
		{
		return {
			//language=HTML
			wrapper: `
				<div class="pf-slider-ul" pf="ul">
				</div>
			`,
			//language=HTML
			preloader: `
				<div class="preloader-container" pf="preloaderContainer">
					<div class="preloader" pf="preloader"></div>
				</div>
			`,
		};
		}

	init()
		{
		super.init();
		this.dom.element.append(this.dom.preloader);
		this.dom.element.addClass('pf-slider');

		this.dom.element.on('slideRight', () => this.backward());
		this.dom.element.on('slideLeft', () => this.forward());

		this.dom.element.on('dndStart', (event) => {
			this.dl = event.point.left - this.dom.element.offset().left;
			this.dom.ul.css('transition', 'none');
		});
		this.dom.element.on('dndDrag', (event) => {
			this.dom.ul.css('margin-left', (-this.current * this.dom.element.width()) + (event.point.left - this.dom.element.offset().left - this.dl) + 'px');
		});
		this.dom.element.on('dndStop', (event) => {
			this.dom.ul.css('margin-left', (-this.current * this.dom.element.width()) + 'px');
			this.dom.ul.css('transition', '.3s');
			let margin = (-this.current * this.dom.element.width()) + (event.point.left - this.dom.element.offset().left - this.dl);
			this.current = PF.H.round(-margin / this.dom.element.width());
			this.current = Math.min(Math.max(this.current, 0), this.size - 1);
			this.currentItem = this[this.current];
		});

		this.on('beforeItemRender', () => this.dom.ul.css('transition', 'none'));
		this.onChange('currentItem.index', () => {
			this.current = this.currentItem.index;
			this.setPosition();
			setTimeout(() => this.dom.ul.css('transition', '.3s'), 50);
		});
		}

	forward()
		{
		console.log('forward');
		this.current = Math.min(this.current + 1, this.size - 1);
		this.currentItem = this[this.current];
		}

	backward()
		{
		console.log('backward');
		this.current = Math.max(this.current - 1, 0);
		this.currentItem = this[this.current];
		}

	setPosition()
		{
		this.dom.ul.css('margin-left', (-this.current * this.dom.element.width()) + 'px');
		}

	};


PF.Slider.Item = class Item extends PF.List.Item
	{
	static get options()
		{
		return {};
		}

	get renderer()
		{
		//language=HTML
		return `
			<div class="pf-slider-item" pf="item">${this.itemInner}</div>
		`;
		}

	get itemInner()
		{
		//language=HTML
		return ``;
		}

	init()
		{

		}

	onRender()
		{
		super.onRender();

		}

	};
